import { useState } from 'react';
import { useAccount } from 'wagmi';
import { api } from './api';
import { Button } from '~/core/components/Button';
import { useToast } from '~/core/contexts/ToastContext';

export default function ResetSelfExclusionPage() {
  const { address } = useAccount();
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handleResetRestriction = async () => {
    if (!address) {
      toast.error('Please connect your wallet first');
      return;
    }

    setLoading(true);
    try {
      await api.removeRestriction(address);
      toast.success('Self-exclusion restriction reset successfully');
    } catch (error: any) {
      console.error('Failed to reset restriction:', error);
      toast.error(error.message || 'Failed to reset restriction');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#0F0F0F] text-white p-4">
      <div className="max-w-md w-full bg-[#1A1A1A] rounded-2xl p-8 border border-[#2A2A2A] shadow-2xl">
        <h1 className="text-2xl font-bold mb-6 text-center">Reset Self-Exclusion</h1>
        <p className="text-gray-400 mb-8 text-center text-sm">
          Click the button below to reset your self-exclusion restriction.
        </p>
        
        <Button
          onClick={handleResetRestriction}
          disabled={loading || !address}
          className="w-full py-3 text-base font-semibold bg-primary hover:bg-primary-dark transition-all disabled:opacity-50"
        >
          {loading ? 'Processing...' : 'Reset Restriction'}
        </Button>

        {!address && (
          <p className="mt-4 text-sm text-center text-red-500">
            Please connect your wallet to proceed.
          </p>
        )}
      </div>
    </div>
  );
}
